const purchaseType = [
    {
        value: 1,
        label: '公开招标',
    },
    {
        value: 2,
        label: '邀请招标',
    },
    {
        value: 6,
        label: '询比采购',
    },
    {
        value: 7,
        label: '谈判采购',
    },
    {
        value: 4,
        label: '直接采购',
    },
    {
        value: 10,
        label: '竞价采购',
    },
]

const getPurchaseTypeName = function (key) {
    const exist = purchaseType.find((t) => t.value === key)
    return exist ? exist.label : ''
}

module.exports = {
    purchaseType,
    getPurchaseTypeName,
}
